import {
  AfterContentChecked,
  Component,
  ContentChildren,
  HostBinding,
  Input,
  OnChanges,
  OnInit,
  QueryList,
  SimpleChanges,
} from '@angular/core';

import { EMMAFormElementComponent } from './emma-form-element.component';
import { getCurrentLanguage } from '@platform/services/locale.service';
import { getEmmaDocsUrl } from '@emma-helpers/emma-utils';

@Component({
    selector: '[emma-label]',
    templateUrl: './emma-label.component.html',
    standalone: false
})
export class EMMALabelComponent implements OnInit, OnChanges, AfterContentChecked {
  @ContentChildren(EMMAFormElementComponent, { descendants: true })
  _elements!: QueryList<EMMAFormElementComponent>;

  // Force states
  @Input() required = false;
  @Input() disabled = false;
  @Input() hiddenLabel = false;
  @Input() removeOnEmpty = false;

  // Internal states
  innerRequired = false;
  innerDisabled = false;

  // Label
  @Input() first = false;
  @Input() label = '';
  @Input() labelSuffix = '';
  @Input() helpText = '';
  @Input() helpLink: string | { [lang: string]: string } = '';
  @Input() helpLinkLabel = $localize`Saber más`;

  @HostBinding('class') containerClass = 'form-group m-form__group m-form__group--md';
  _containerClass = '';

  ngOnInit(): void {
    this.updateClasses();
  }

  /**
   * Devuelve la URL de ayuda adecuada según el idioma y el input recibido
   */
  getResolvedHelpLink(): string {
    if (!this.helpLink) {
      return getEmmaDocsUrl();
    }
    if (typeof this.helpLink === 'string') {
      return this.helpLink;
    }
    const currentLang = getCurrentLanguage();
    return this.helpLink[currentLang] ?? Object.values(this.helpLink)[0] ?? '';
  }

  ngAfterContentChecked(): void {
    this.updateProps();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if ('labelClass' in changes || 'color' in changes) {
      this.updateClasses();
    }
    if ('required' in changes || 'disabled' in changes) {
      this.updateProps();
    }
  }

  /**
   * Update CSS classes
   */
  private updateClasses() {
    this._containerClass = `emma-label ${this.containerClass} ${this.first ? 'm-form__group--first' : ''}`;
  }

  /**
   * Calculate props
   */
  private updateProps() {
    this.innerRequired = Boolean(
      this.required || (this._elements?.length && this._elements.some((el) => Boolean(el.required)))
    );
    this.innerDisabled = Boolean(
      this.disabled || (this._elements?.length && !this._elements.some((el) => !el.disabled))
    );
  }
}
